import { Injectable } from '@angular/core';
import { State } from '@ansys-internal/awf-angular/store';
import { AWCListItem } from '@ansys-internal/awc-angular/lists';
import { TemplatesService } from '../../../api';

@Injectable({
  providedIn: 'root',
})
export class TemplateListService implements TemplateListService {
  constructor(
    private state: State,
    private templatesService: TemplatesService
  ) {}

  async getTemplates(): Promise<AWCListItem[]> {
    return new Promise((resolve, reject) => {
      this.templatesService.listTemplatesTemplatesListGet().subscribe(
        (templateList) => {
          const mappedTemplate = templateList.map((template) => ({
            id: template.design_instance_id, // TODO: Template list need to pass design_id (API side)
            text: template.name,
          }));

          resolve(mappedTemplate as AWCListItem[]);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }
}
